<template>
  <div>
    <b-container class="container card">
      <!-- search -->
      <div id="search" v-if="search" class="card">
        <div class="card-header">
          <div>
            <i class="fa fa-search"></i>
            <span>بحث</span>
          </div>
        </div>
        <div class="card-body">
          <div class="container">
            <div class="form row card-search">
              <div class="form-group col-md-3">
                <label for="">كود السند</label>
                <input type="text" class="form-control" v-model="s_id" />
              </div>
              <div class="form-group col-md-3">
                <label for="">جهة الصرف</label>
                <select
                  class="browser-default custom-select"
                  v-model="s_accType"
                >
                  <option
                    v-for="acc in accountType.filter((t) => t.accountType == 2)"
                    :value="acc.id"
                    :key="acc.id"
                  >
                    <span> {{ acc.accountName }} </span>
                  </option>
                </select>
              </div>
              <div class="form-group col-md-3 ">
                <label for=""> تاريخ الصرف من</label>
                <div class="form-inline">
                  <select
                    name=""
                    id="lcStart"
                    class="col-md-3 select-par"
                    v-model="lcStart"
                  >
                    <option value="1"><span>اكبر من</span></option>
                    <option value="2"><span>اصغر من</span></option>
                    <option value="3"><span>يساوى</span></option>
                  </select>
                  <input
                    id="id_withdrawDateF"
                    type="text"
                    @blur="s_withdrawDateF1"
                    class="form-control hijri-date-input col-md-9"
                    v-bind:value="s_withdrawDateF"
                  />
                </div>
              </div>
              <div class="form-group col-md-3 ">
                <label for=""> تاريخ الصرف الى </label>
                <div class="form-inline">
                  <select
                    name=""
                    id="lcEnd"
                    class="col-md-3 select-par"
                    v-model="lcEnd"
                  >
                    <option value="1"><span>اكبر من</span></option>
                    <option value="2"><span>اصغر من</span></option>
                    <option value="3"><span>يساوى</span></option>
                  </select>
                  <input
                    id="id_withdrawDateT"
                    type="text"
                    @blur="s_withdrawDateT1"
                    class="form-control hijri-date-input col-md-9"
                    v-bind:value="s_withdrawDateT"
                  />
                </div>
              </div>

              <div class="form-group col-md-3 p-4">
                <button @click="clear" class="btn btn-danger">
                  الغاء البحث
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- **************************** crud  **********************************-->
      <div id="crud" v-if="crud" class="card">
        <div v-if="add" class="card-header bg-primary ">
          <div>
            <i class="fa fa-plus"></i>
            <span>إضافة</span>
          </div>
        </div>
        <div v-if="edit" class="card-header bg-warning">
          <div>
            <i class="fa fa-pen-nib"></i>
            <span>تعديل</span>
          </div>
        </div>
        <form action="" @submit.prevent="submit">
          <div class="card-body">
            <div class="container">
              <div class="form row card-search">
                <div class="form-group col-md-3">
                  <label for="">كود السند</label>
                  <input
                    disabled
                    type="text"
                    class="form-control"
                    v-model.trim="$v.id.$model"
                    :class="{
                      'is-invalid': $v.id.$error,
                      'is-valid': !$v.id.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">من حساب</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.FromAccount.$model"
                    :class="{
                      'is-invalid': $v.FromAccount.$error,
                      'is-valid': !$v.FromAccount.$invalid,
                    }"
                  >
                    <option v-for="box in boxes" :value="box.id" :key="box.id">
                      <span> {{ box.accountName }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.FromAccount.required">هذا الحقل مطلوب</span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">الى حساب</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.accType.$model"
                    @change="accTypeChange()"
                    :class="{
                      'is-invalid': $v.accType.$error,
                      'is-valid': !$v.accType.$invalid,
                    }"
                  >
                    <option
                      v-for="act in accountType"
                      :value="act.id"
                      :key="act.id"
                    >
                      <span> {{ act.accountName }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.accType.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
                <div v-if="empShow" class="col-12 row mb-4 mr-0 bg-white">
                  <div class="form-group col-md-4 offset-md-8">
                    <label for="">السائق</label>
                    <select
                      class="browser-default custom-select"
                      v-model.trim="$v.empID.$model"
                      :class="{
                        'is-invalid': $v.empID.$error,
                        'is-valid': !$v.empID.$invalid,
                      }"
                    >
                      <option v-for="emp in emps" :value="emp.id" :key="emp.id">
                        <span> {{ emp.id }} </span> <span> | </span>
                        <span> {{ emp.Fname }} </span>
                        <span> {{ emp.Ffname }} </span>
                      </option>
                    </select>
                    <div class="invalid-feedback"></div>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">عدد الاشتراكات</span>
                    <span> : </span>
                    <span class="text-danger">{{ subCount }} </span>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">إجمالى الاشتراكات</span>
                    <span> : </span>
                    <span class="text-danger">{{ subTotal }} </span>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">المسدد من الاشتراكات</span>
                    <span> : </span>
                    <span class="text-danger">{{ subPaid }} </span>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">الراتب</span>
                    <span> : </span>
                    <span class="text-danger">{{ subSalary }} </span>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">مدين</span>
                    <span> : </span>
                    <span class="text-danger">{{ subDeptor }} </span>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">دائن</span>
                    <span> : </span>
                    <span class="text-danger">{{ subCreditor }} </span>
                  </div>
                </div>

                <div v-if="stdShow" class="col-12 row mb-4 mr-0 bg-white">
                  <div class="form-group col-md-4 offset-md-8">
                    <label for="">الطالب</label>
                    <select
                      class="browser-default custom-select"
                      @change="accTypeChange()"
                      v-model.trim="$v.stdID.$model"
                      :class="{
                        'is-invalid': $v.stdID.$error,
                        'is-valid': !$v.stdID.$invalid,
                      }"
                    >
                      <option
                        v-for="std in students"
                        :value="std.id"
                        :key="std.id"
                      >
                        <span> {{ std.Fname }} </span>
                        <span> {{ std.Ffname }} </span>
                      </option>
                    </select>
                    <div class="invalid-feedback"></div>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">مدين</span>
                    <span> : </span>
                    <span class="text-danger">{{ stdDeptor }} </span>
                  </div>
                  <div class="col-2">
                    <span class="text-primary">دائن</span>
                    <span> : </span>
                    <span class="text-danger">{{ stdCreditor }} </span>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">تاريخ الصرف</label>

                  <input
                    id="id_withdrawDate"
                    type="text"
                    @blur="withdrawDate1"
                    class="form-control hijri-date-input"
                    v-bind:value="$v.withdrawDate.$model"
                    :class="{
                      'is-invalid': $v.withdrawDate.$error,
                      'is-valid': !$v.withdrawDate.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.withdrawDate.required"
                      >هذا الحقل مطلوب</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">التفاصيل</label>
                  <textarea
                    type="text"
                    class="form-control"
                    v-model.trim="$v.Details.$model"
                    :class="{
                      'is-invalid': $v.Details.$error,
                      'is-valid': !$v.Details.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">نوع الصرف</label>
                  <select
                    class="browser-default custom-select"
                    v-model.trim="$v.withdrawType.$model"
                    :class="{
                      'is-invalid': $v.withdrawType.$error,
                      'is-valid': !$v.withdrawType.$invalid,
                    }"
                  >
                    <option
                      v-for="pty in payType"
                      :value="pty.id"
                      :key="pty.id"
                    >
                      <span> {{ pty.pType }} </span>
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="!$v.withdrawType.required"
                      >هذا الحقل مطلوب</span
                    >
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">رقم الشيك</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.check.$model"
                    :class="{
                      'is-invalid': $v.check.$error,
                      'is-valid': !$v.check.$invalid,
                    }"
                  />
                  <div class="invalid-feedback"></div>
                </div>
                <div class="form-group col-md-3">
                  <label for="">مدين</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.trim="$v.deptor.$model"
                    :class="{
                      'is-invalid': $v.deptor.$error,
                      'is-valid': !$v.deptor.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.deptor.required">هذا الحقل مطلوب</span>
                  </div>
                </div>

                <div class="form-group col-md-3">
                  <label for="">دائن</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.trim="$v.creditor.$model"
                    :class="{
                      'is-invalid': $v.creditor.$error,
                      'is-valid': !$v.creditor.$invalid,
                    }"
                  />
                  <div class="invalid-feedback">
                    <span v-if="!$v.creditor.required">هذا الحقل مطلوب</span>
                  </div>
                </div>
              </div>

              <div v-if="add" class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      style="background-color:#007bff !important;"
                      class="col-md-6 btn-primary"
                      type="submit"
                      :disabled="busy"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ addEdit }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="cancelCrud"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
              <div v-if="edit" class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-warning"
                      type="submit"
                      :disabled="busy"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ addEdit }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ul class="nav nav-tabs view-mode">
        <li class="nav-item ">
          <a class="nav-link active" data-toggle="tab" href="#home">
            <i class="fa fa-table"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#menu1">
            <i class="fa fa-bars"></i>
          </a>
        </li>
      </ul>
      <!-- **************************** add button **********************************-->
      <div class="m-auto">
        <b-button v-if="c_add" @click="insert" variant="outline-primary">إضافة</b-button>
        <div class="std-count">
          <span class="text-danger">
            عدد السندات
          </span>
          <span> | </span>
          <span class="text-success"> {{ items.length }} </span>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-pane container active overflow" id="home">
          <!-- Main table element -->

          <b-table
            :busy="isBusy"
            :bordered="true"
            :no-border-collapse="true"
            show-empty
            striped
            hover
            small
            stacked="sm"
            :fields="fields"
            :current-page="currentPage"
            :per-page="10"
            :items="filtered"
            head-variant="dark"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            sort-icon-left
          >
            <template v-slot:head(id) style="background-color:red;">
              <span class="text-info">كود السند</span>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> جارى التحميل ... </strong>
              </div>
            </template>
            <template v-slot:table-colgroup="scope">
              <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.key === 'id' ? '20px' : '20px' }"
              />
            </template>
            <template slot="top-row" slot-scope="{ fields }">
              <td v-for="field in fields" :key="field.key">
                <input
                  v-model="filters[field.key]"
                  :placeholder="field.label"
                />
              </td>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
              v-if="c_update"
                size="sm"
                @click="update(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-warning"
              >
                تعديل
              </b-button>
              <b-button
              v-if="c_delete"
                size="sm"
                @click="info(row.item, row.index, $event.target)"
                class="mr-1"
                variant="outline-danger"
              >
                حذف
              </b-button>
            </template>
          </b-table>
          <b-row>
            <b-col sm="7" md="6" class="m-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class=""
              ></b-pagination>
            </b-col>
          </b-row>
          <!-- Info modal -->
          <b-modal
            :id="infoModal.id"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center">
              <b-row>
                <div class="card-body">
                  <span>
                    هل انت متأكد من حذف السند رقم
                    <span class="text-primary">{{ delitem.id }}</span> ؟
                  </span>
                  <span class="text-dark">{{ delitem.boardNum }}</span>
                </div>
              </b-row>
              <div class="card-footer">
                <b-container>
                  <b-row>
                    <b-button
                      class="col-md-6 btn-danger"
                      :disabled="busy"
                      @click="remove(delitem)"
                    >
                      <b-spinner
                        v-if="busy"
                        small
                        type="grow"
                        style="margin-bottom: 3px;"
                      ></b-spinner>
                      {{ btnDelMessage }}</b-button
                    >
                    <b-button class="col-md-6 btn-secondary" @click="hideModal"
                      >الغاء</b-button
                    >
                  </b-row>
                </b-container>
              </div>
            </div>
          </b-modal>
          <!-- Add/update -->
          <b-modal
            id="updateModal"
            hide-footer
            ref="my-modal"
            body-bg-variant="light"
            body-text-variant="danger"
            footer-bg-variant="warning"
            footer-text-variant="light"
            @hide="resetInfoModal"
          >
            <div class="d-block text-center"></div>
          </b-modal>
        </div>
        <div class="tab-pane container fade" id="menu1">
          <div class="container">
            <div class="row">
              <div class="col-md-3" v-for="item in items" :key="item.id">
                <div class="itm card">
                  <div class="card-header">
                    <span>كود السند</span>
                    <span> | </span>
                    <span class="text-warning"> {{ item.id }} </span>
                  </div>
                  <table>
                    <tr>
                      <td>جهة الصرف</td>
                      <td>|</td>
                      <td>{{ item.accountName }}</td>
                    </tr>
                    <tr>
                      <td>تاريخ الصرف</td>
                      <td>|</td>
                      <td>{{ item.payDate }}</td>
                    </tr>

                    <tr>
                      <td>نوع القبض</td>
                      <td>|</td>
                      <td>{{ item.pType }}</td>
                    </tr>
                    <tr>
                      <td>مدين</td>
                      <td>|</td>
                      <td>{{ item.deptor }}</td>
                    </tr>
                    <tr>
                      <td>دائن</td>
                      <td>|</td>
                      <td>{{ item.creditor }}</td>
                    </tr>
                  </table>

                  <div class="card-footer m-auto">
                    <b-button
                    v-if="c_update"
                      size="sm"
                      class="mr-1"
                      @click="update(item)"
                      variant="outline-warning"
                    >
                      تعديل
                    </b-button>
                    <b-button
                    v-if="c_delete"
                      size="sm"
                      @click="infoDel(item.id)"
                      class="mr-1"
                      variant="outline-danger"
                    >
                      حذف
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import indexLayout from "../../layouts/indexLayout.vue";
import $ from "jquery";
export default {
  name: "income",
  data() {
    return {
      s_id: "",
      s_withdrawDateF: "",
      s_withdrawDateT: "",
      s_accType: "",
      id: "",
      withdrawDate: "",
      accType: "",
      empID: "",
      stdID: "",
      Details: "",
      withdrawType: "",
      FromAccount: "",
      check: "",
      deptor: "",
      creditor: "",
      lcStart: "",
      lcEnd: "",
      /*emp details */
      empShow: false,
      subCount: "",
      subTotal: "",
      subPaid: "",
      subSalary: "",
      subDeptor: "",
      subCreditor: "",
      /*emp details */
      /*emp details */
      stdShow: false,
      stdDeptor: "",
      stdCreditor: "",
      /*emp details */

      search: true,
      crud: false,
      add: false,
      edit: false,
      isBusy: true,
      busy: false,
      addEdit: null,
      btnDelMessage: "حذف",
      items: [],
      delitem: "",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "warning",
      footerTextVariant: "dark",
           /*check role */
c_add:false,
c_update:false,
c_delete:false,

/*check end */
      fields: [
        {
          key: "id",
          label: "كود السند",
          sortable: true,
          class: "f-id",
          sortDirection: "desc",
          tdClass: "fid",
        },
        {
          key: "accountName",
          label: "جهة الصرف",
          sortable: true,
          class: "text-center",
        },
        {
          key: "pType",
          label: "نوع الصرف",
          sortable: true,
          class: "text-center",
        },
        {
          key: "deptor",
          label: "مدين",
          sortable: true,
          class: "text-center",
        },
        {
          key: "creditor",
          label: "دائن",
          sortable: true,
          class: "text-center",
        },
        {
          key: "withdrawDate",
          label: "تاريخ الصرف",
          sortable: true,
          class: "text-center",
        },

        { key: "actions", label: "" },
      ],
      filters: {
        id: "",
        withdrawDate: "",
        accType: "",
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  validations: {
    id: {},
    withdrawDate: {
      required,
      isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
      },
    },
    accType: { required },
    Details: {},
    withdrawType: { required },
    FromAccount: { required },
    check: {},
    stdID: {},
    empID: {},
    deptor: { required },
    creditor: { required },
  },
    created(){
      this.$emit('update:layout',indexLayout)
      this.Role_check();
    },
  computed: {
    ...mapGetters({
      load: "outMod/GET_ALLDATA",
       checkR : "GET_ROLES"
    }),
    ...mapState(["accountType", "payType", "boxes", "emps", "students"]),

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key]).includes(this.filters[key])
        );
      });
      return filtered.length > 0
        ? filtered
        : [
            {
              id: "",
              withdrawDate: "",
              accType: "",
            },
          ];
    },
  },
  mounted() {
    this.getData();
    this.loadDatePicker();
  },
  methods: {
    ...mapActions({
      loadData: "outMod/fetchData",
      addData: "outMod/addData",
      updateData: "outMod/updateData",
      deleData: "outMod/deleteData",
    }),
    insert: function() {
      this.addEdit = "إضافة";
      this.$v.$reset();
      this.clearCrud();
      this.search = false;
      this.crud = true;
      this.add = true;
      this.edit = false;
      this.empShow = false;
      this.stdShow = false;
      window.scrollTo(0, 0);
      this.loadDatePicker();
    },
    update(item) {
      this.addEdit = "تعديل";
      this.delitem = item;
      this.search = false;
      this.crud = true;
      this.add = false;
      this.edit = true;
      this.editLood();
      this.empShow = false;
      this.stdShow = false;
      if (item.stdID != null) {
        this.stdShow = true;
      }
      if (item.empID != null) {
        this.empShow = true;
      }
      window.scrollTo(0, 0);
      this.loadDatePicker();
    },
    s_withdrawDateF1() {
      var st = $("#id_withdrawDateF").val();
      this.s_withdrawDateF = st;
    },
    s_withdrawDateT1() {
      var st = $("#id_withdrawDateT").val();
      this.s_withdrawDateT = st;
    },
    withdrawDate1() {
      var st = $("#id_withdrawDate").val();
      this.withdrawDate = st;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.delitem = item;
      this.search = true;
      this.crud = false;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },

    infoDel: function(id) {
      var item = this.items.find((todo) => todo.id == id);
      this.infoModal.title = item.id;
      this.delitem = item;
      this.search = true;
      this.crud = false;
      this.$root.$emit("bv::show::modal", this.infoModal.id);
    },
    async remove(stdRow) {
      this.busy = true;
      await this.deleData(stdRow);
      this.btnDelMessage = "تم الحذف";
      this.busy = false;
      this.items = this.load;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
      } else {
        var std = {
          id: this.id,
          withdrawDate: this.withdrawDate,
          accType: this.accType,
          Details: this.Details,
          stdID: this.stdID,
          empID: this.empID,
          withdrawType: this.withdrawType,
          FromAccount: this.FromAccount,
          check: this.check,
          deptor: this.deptor,
          creditor: this.creditor,
        };
        this.busy = true;
        if (this.add == true) {
          await this.addData(std);
          var state1 = this.$store.getters["outMod/getMsg"];
          if (state1 <= 201) {
            this.search = true;
            this.crud = false;
            this.loadDatePicker();
            this.addEdit = "تم الاضافة";
          } else {
            this.addEdit = "خطأ";
          }
        }
        if (this.edit == true) {
          await this.updateData(std);
          var state2 = this.$store.getters["outMod/getMsg"];
          if (state2 <= 201) {
            this.search = true;
            this.crud = false;
            this.loadDatePicker();
            this.addEdit = "تم التعديل";
          } else {
            this.addEdit = "خطأ";
          }
        }

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.busy = false;
          this.submitStatus = "تم الحفظ";
        }, 500);
      }
    },
    cancelCrud() {
      this.search = true;
      this.crud = false;
      this.loadDatePicker();
    },
    hideModal() {
      this.search = true;
      this.crud = false;
      this.loadDatePicker();
      this.$root.$emit("bv::hide::modal", this.infoModal.id);
    },
    clearCrud() {
      this.s_id = "";
      this.s_withdrawDateF = "";
      this.s_withdrawDateT = "";
      this.s_accType = "";
      this.id = "";
      this.withdrawDate = "";
      this.accType = "";
      this.Details = "";
      this.stdID = "";
      this.empID = "";
      this.withdrawType = "";
      this.FromAccount = "";
      this.check = "";
      this.deptor = "";
      this.creditor = "";
    },
    editLood() {
      this.s_id = "";
      this.s_withdrawDateF = "";
      this.s_withdrawDateT = "";
      this.s_accType = "";
      this.id = this.delitem.id;
      this.withdrawDate = this.delitem.withdrawDate;
      this.accType = this.delitem.accType;
      this.Details = this.delitem.Details;
      this.empID = this.delitem.empID;
      this.stdID = this.delitem.stdID;
      this.withdrawType = this.delitem.withdrawType;
      this.FromAccount = this.delitem.FromAccount;
      this.check = this.delitem.check;
      this.deptor = this.delitem.deptor;
      this.creditor = this.delitem.creditor;
    },
    async getData() {
      await this.$store.dispatch("outMod/fetchData");
        this.items = this.load;
        this.totalRows = this.items.length;
        this.isBusy = false;
      // if (this.load.length > 0) {
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // } else {
      //   await this.$store.dispatch("outMod/fetchData");
      //   this.items = this.load;
      //   this.totalRows = this.items.length;
      //   this.isBusy = false;
      // }
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Cfilter() {
      this.items = this.load;
      this.items = this.items.filter((t) =>
        t.id.toString().includes(this.s_id)
      );

      this.items = this.items.filter((t) =>
        t.accType.toString().includes(this.s_accType)
      );

      if (this.s_withdrawDateF != "") {
        if (this.lcStart == 1) {
          this.items = this.items.filter(
            (t) => t.withdrawDate >= this.s_withdrawDateF
          );
        } else if (this.lcStart == 2) {
          this.items = this.items.filter(
            (t) => t.withdrawDate <= this.s_withdrawDateF
          );
        } else if (this.lcStart == 3) {
          this.items = this.items.filter(
            (t) => t.withdrawDate == this.s_withdrawDateF
          );
        }
      }
      if (this.s_withdrawDateT != "") {
        if (this.lcEnd == 1) {
          this.items = this.items.filter(
            (t) => t.withdrawDate >= this.s_withdrawDateT
          );
        } else if (this.lcEnd == 2) {
          this.items = this.items.filter(
            (t) => t.withdrawDate <= this.s_withdrawDateT
          );
        } else if (this.lcEnd == 3) {
          this.items = this.items.filter(
            (t) => t.withdrawDate == this.s_withdrawDateT
          );
        }
      }
    },
    clear() {
      this.s_id = "";
      this.s_withdrawDateF = "";
      this.s_withdrawDateT = "";
      this.s_accType = "";
    },
    loadDatePicker() {
      let ckeditor = document.createElement("script");
      ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
      document.body.appendChild(ckeditor);
    },
      Role_check(){
this.c_add =this.checkR.outcome_add ==1 ? true : false;
this.c_update =this.checkR.outcome_update ==1 ? true : false;
this.c_delete =this.checkR.outcome_delete ==1 ? true : false;


},
    accTypeChange() {
      if (this.accType == 3) {
        this.stdShow = false;
        this.empShow = true;
      } else if (this.accType == 4) {
        this.empShow = false;
        this.stdShow = true;
      } else {
        this.empShow = false;
        this.stdShow = false;
      }
    },
  },
  watch: {
    s_id: function() {
      this.Cfilter();
    },
    s_accType: function() {
      this.Cfilter();
    },
    s_withdrawDateF: function() {
      this.Cfilter();
    },
    s_withdrawDateT: function() {
      this.Cfilter();
    },
    empID: async function() {
      var dat = await this.$store.getters["outMod/getEmpSub"](this.empID);
      this.subCount = dat.subCount;
      this.subTotal = dat.subTotal;
      this.subPaid = dat.subPaid;
      this.subSalary = dat.subSalary;
      this.subDeptor = dat.subDeptor;
      this.subCreditor = dat.subCreditor;
    },
    stdID: async function() {
      var dat = await this.$store.getters["outMod/getStdSub"](this.stdID);
      this.stdDeptor = dat.stdDeptor;
      this.stdCreditor = dat.stdCreditor;
    },
  },
};
</script>
<style lang="scss" scoped>
.b-table-top-row > td:last-child {
  visibility: hidden;
}
.nav-link.active {
  background-color: #ddab2b !important;
}
.fid {
  background-color: #ddab2b;
}
.itm {
  margin: 10px 0px;
  box-shadow: 0px 0px 6px 1px black;
  -moz-box-shadow: 0px 0px 6px 1px black;
  -o-box-shadow: 0px 0px 6px 1px black;
  -webkit-box-shadow: 0px 0px 6px 1px black;
}
.dropdown-menu {
  z-index: 1600 !important; /* has to be larger than 1050 */
}
</style>
